import { render, staticRenderFns } from "./PreviousIndexing.vue?vue&type=template&id=2b95a57f&scoped=true&"
import script from "./PreviousIndexing.vue?vue&type=script&lang=js&"
export * from "./PreviousIndexing.vue?vue&type=script&lang=js&"
import style0 from "./PreviousIndexing.vue?vue&type=style&index=0&id=2b95a57f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95a57f",
  null
  
)

export default component.exports